<template>
  <div>
    <v-layout
      wrap
      justify-center
      fill-height
      class="select-page"
      style="position: relative; margin-bottom: 35px"
    >
      <div
        v-if="!filterBots || filterBots.length == 0"
        class="my-4 text-xs-center"
        style="color: #fff"
      >
        {{ $t('No Data') }}
      </div>
      <template v-else>
        <AccountItem v-for="bot in filterBots" :key="'bot_' + bot.pageid" :bot="bot" />
      </template>
      <v-flex
        v-if="isFacebook"
        xs6
        sm4
        md3
        lg2
        class="page pa-3"
        style="cursor: pointer"
        @click="$emit('onAddBot')"
      >
        <v-responsive aspect-ratio="1:1">
          <vue-simple-svg
            :filepath="'/static/img/assets/_global/page-plus.svg'"
            style="min-width: 100%"
            height="auto"
            fill="white"
            class="page-image"
          />
        </v-responsive>
        <div class="page-name text-xs-center white--text mt-2 mb-2">
          {{ $t('Add') }}
        </div>
      </v-flex>
    </v-layout>
    <v-btn
      v-if="isShowMore"
      :loading="loading"
      :disabled="loading"
      x-large
      block
      outline
      color="white"
      @click="getMore"
      >MORE</v-btn
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountItem from './AccountItem.vue'
export default {
  components: {
    AccountItem
  },
  props: {
    dirtySearch: {
      type: String,
      default: ''
    },
    itemPerPage: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      loading: false,
      offset: 0,
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      isFacebook: 'isFacebook',
      botlist: 'botlist'
    }),
    filterBots() {
      const bots = Array.isArray(this.botlist) ? this.botlist : []
      const search = (this.dirtySearch || '').toLowerCase().trim()
      const filtered = search
        ? bots.filter((bot) => {
            const name = (bot && bot.pagename ? String(bot.pagename) : '').toLowerCase()
            const id = (bot && bot.pageid ? String(bot.pageid) : '').toLowerCase()
            return name.includes(search) || id.includes(search)
          })
        : bots
      return filtered.slice(0, this.page * this.itemPerPage)
    },
    isShowMore() {
      const listLength = Array.isArray(this.botlist) ? this.botlist.length : 0
      if ((this.dirtySearch || '').trim()) {
        return this.filterBots.length >= this.itemPerPage * this.page
      }
      return listLength >= this.itemPerPage * this.page
    }
  },
  watch: {
    dirtySearch() {
      this.page = 1
      this.offset = 0
    }
  },
  methods: {
    getMore() {
      this.page++
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/AccountForAdmin.vue